 <template>
    <v-content>
        <v-container fluid grid-list-xl style="top: -110px; left: 0px;" class="card-animate-2">
          <v-layout row wrap>
            <v-flex sm12 xs12 md12 lg12>
                                <!-- <Animation24 class="animation4"/> -->
                <Animation9 class="animation3" />
                <v-img class="image card-animate-2" style="margin-block: -50px;" src="../assets/assets/CFBG11.png"></v-img>
                <v-row class="avatar">
                  <!-- <template v-slot:activator="{ on, attrs }">
                <v-avatar color="primary" size="46" v-bind="attrs" v-on="on">
                  <img v-bind:src="userInfo.profilePic" />
                </v-avatar>
                <span class="avatar-name" v-bind="attrs" v-on="on">{{
                  userInfo.name
                }}</span>
              </template> -->

                  <v-list-item>
                    <v-list-item-avatar size="120">
                      <img v-bind:src="userInfo.profilePic" />
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title
                        style="margin-top:10px; font-size: 26px; font-weight: 100;"
                        color="primary"
                        >{{ userInfo.name }}</v-list-item-title
                      >
                      <v-list-item-subtitle 
                        style="margin-top:10px; font-size: 26px; font-weight: 100;"
                        color="primary"
                        >{{ userInfo.position }}</v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-row>

            </v-flex>
          </v-layout>
        </v-container>

    </v-content>

</template>

<script>
import Animation9 from "@/components/Animation9.vue";
// import Animation24 from "@/components/Animation24.vue";

export default {
  name: 'Users',
  components: {
    Animation9,
    // Animation24,
  },
  data() {
    return {
      scrollInvoked: 0,
      department: [
        'Retail',
        'Telemarketing',
        'Marketing',
        'Processing',
        'Repair',
        'Online',
        'Operations',
        'Sales',
        'Finance',
        'Human Resources',
        'Customer Service',
        'Wholesale',
      ],
      position: [
        'Sales Associate',
        'Senior Sales Associate',
        'Retail Sales Associate',
        'Retail Operations Director',
        'Marketing Director',
        'Operations Manager',
        'Processing Manager',
        'Sales Director',
        'Online Sales',
        'Online Operations',
        'Repair Technician',
        'Chief Executive Officer',
        'Chief Sales Officer',
        'Chief Operations Officer',
      ],
      role: ['Adminstrator', 'Manager', 'Employee', 'Executive'],
      items: [],
      userInfo: {},
      usersList: [],
      searchKey: '',
      search: '',
      optionIndex: 0,
      itemToBeDeleted: '',
      loading3: false,
      isLoading: false,
      productLoader: false,
      editForm: false,
      showConfirmation: false,
      overlay: false,
      rows: 100,
      itemsPerPage: 10,
      currentField: 0,
      tableLoader: false,
      date: '',
      formFields: {
        firstName: '',
        lastName: '',
        department: '',
        position: '',
        role: '',
        mobile: '',
        email: '',
        extension: '',
      },
      modal_date_picker: false,
      form_valid: true,
      headers: [
        {
          text: ' Name',
          value: 'fullName',
          align: 'center',
          sortable: false,
          divider: true,
        },
        {
          text: 'Department',
          value: 'department',
          align: 'center',
          divider: true,
        },
        { text: 'Position', value: 'position', align: 'center', divider: true },
        {
          text: 'Role',
          value: 'role',
          align: 'center',
          divider: true,
        },
        { text: 'Mobile', value: 'mobile', align: 'center', divider: true },
        {
          text: 'Email',
          value: 'email',
          align: 'center',
          divider: true,
        },
        {
          text: 'Extension',
          value: 'extension',
          align: 'center',
          divider: true,
        },
        {
          text: '',
          value: 'controls',
          align: 'center',
          sortable: true,
          divider: true,
        },
      ],
    };
  },

  mounted() {
    this.getUsersList();
    let profile = JSON.parse(localStorage.getItem('currentUser'));
    this.userInfo = profile;
    Event.$on('openForm', () => {
      // Event.$off();
      console.log('Starting form in ' + this.$route.path);
      if (this.$route.path !== '/users') {
        return;
      }
      this.readOutLoud('Please fill the following details');
      setTimeout(() => {
        this.readOutLoud('What is the user');
        this.startListining();
      }, 3000);
      this.overlay = true;
    });

    Event.$on('editFromRecord', (data) => {
      if (this.$route.path !== '/users') {
        return;
      }
      console.log(data.msg);
      this.editUser(this.usersList[0]);
    });

    Event.$on('searchFromRecord', (data) => {
      if (this.$route.path !== '/users') {
        return;
      }
      this.search = data.msg;
      this.searchUser(data.msg);
    });

    Event.$on('formDetails', (data) => {
      console.log(data);

      switch (data.msg) {
        case 'next':
          this.currentField++;
          this.navigateField();

          break;
        case 'previous':
          this.currentField--;
          this.navigateField();

          break;
        case 'submit':
          this.readOutLoud('Please verify your details');
          break;
        case 'verified':
          this.overlay = false;
          this.submitForm();
          break;
        default:
          this.fillForm(data.msg);
          break;
      }
    });
  },
  printLead: function() {
    window.print();
  },

  methods: {
    initialize() {
      this.usersList = [];
    },

    onScroll() {
      this.scrollInvoked++;
    },

    searchUser: async function() {
      console.log(this.search);
      if (!this.search) this.getUsersList();

      this.isLoading = true;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}users/search`,
        {
          method: 'POST',
          body: JSON.stringify({ searchText: this.search }), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      const json = await response.json();
      this.isLoading = false;

      console.log(json);
      this.usersList = json.result;
    },

    getUsersList: async function() {
      this.tableLoader = true;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}users/all`
      );
      const json = await response.json();
      console.log(json);
      this.usersList = json.result;
      this.tableLoader = false;
    },

    submitForm: async function() {
      console.log(this.formFields);
      // console.log(this.inputs[0])

      this.loading3 = true;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}users/create`,
        {
          method: 'POST',
          body: JSON.stringify({ ...this.formFields }), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      const json = await response.json(); //extract JSON from the http response
      console.log(json[0]);

      setTimeout(() => {
        this.readOutLoud('User Created');
        this.getUsersList();
        this.resetForm();
      }, 800);
    },

    deleteConfirmation: function(item) {
      this.itemToBeDeleted = item;
      this.showConfirmation = true;
    },

    deleteUser: async function() {
      this.loading3 = true;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}users/delete`,
        {
          method: 'POST',
          body: JSON.stringify({ id: this.itemToBeDeleted._id }), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      const json = await response.json(); //extract JSON from the http response
      console.log(json[0]);
      this.itemToBeDeleted = '';
      this.showConfirmation = false;
      this.loading3 = false;

      setTimeout(() => {
        this.readOutLoud('1 record deleted');
        this.getUsersList();
      }, 800);
    },

    editUser: function(data) {
      this.overlay = true;
      this.editForm = true;
      this.formFields = data;
    },

    updateUser: async function() {
      this.loading3 = true;

      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}users/update`,
        {
          method: 'POST',
          body: JSON.stringify(this.formFields), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      const json = await response.json(); //extract JSON from the http response
      console.log(json[0]);

      setTimeout(() => {
        this.readOutLoud('1 record updated');
        this.getUsersList();
        this.resetForm();
      }, 800);
    },

    resetForm: function() {
      this.overlay = false;
      this.editForm = false;
      this.loading3 = false;
      this.formFields = {
        firstName: '',
        lastName: '',
        department: '',
        position: '',
        role: '',
        mobile: '',
        email: '',
        extension: '',
      };
    },

    openForm: function() {
      this.overlay = true;
      this.items = [];
    },

    startListining: function() {
      setTimeout(() => {
        Event.$emit('speakModeOn');
      }, 1250);
    },

    beforeDestroy() {
      Event.$off('speakModeOn');
      Event.$off('openForm');
      Event.$off('searchFromRecord');
      Event.$off('editFromRecord');
    },

    readOutLoud: (msg) => {
      const speech = new SpeechSynthesisUtterance();
      const voiceName = 'Google UK English Male';
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1;
      speech.voice = speechSynthesis.getVoices().filter(function (voice) {
      return voice.name === voiceName
    })[0]
      speech.text = msg;
      window.speechSynthesis.speak(speech);

     speech.onend = function() {
      setTimeout(() => {
      Event.$emit('speakModeOn');
      }, 3200);
     };
    },

    dateCommand: function(msg) {
      let date;
      var currentDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
      var day = currentDate.getDate();
      var month = currentDate.getMonth() + 1;
      if (month < 9) {
        month = '0' + month;
      }
      var year = currentDate.getFullYear();
      switch (msg) {
        case 'today':
          date = new Date().toISOString().slice(0, 10);
          break;
        case 'tomorrow':
          date = year + '-' + month + '-' + (day + 1);
          break;
        default:
          msg = msg + ' ' + year;
          date = new Date(msg).toISOString().slice(0, 10);
          console.log(date);
          break;
      }

      return date;
    },

    fillForm: function(msg) {
      let firstChar = msg.charAt(0).toUpperCase();
      switch (this.currentField) {
        case 0:
          this.formFields.firstName = msg;
          break;
        case 1:
          this.formFields.lastName = msg;
          break;
        case 2:
          this.formFields.department = this.priority.filter(
            (obj) => obj.indexOf(firstChar) != -1
          )[0];
          break;
        case 3:
          this.formFields.position = this.status.filter(
            (obj) => obj.indexOf(firstChar) != -1
          )[0];
          break;
        case 4:
          this.formFields.role = this.status.filter(
            (obj) => obj.indexOf(firstChar) != -1
          )[0];
          break;
        case 5:
          this.formFields.mobile = msg;
          break;
        case 6:
          this.formFields.email = msg;
          break;
        case 7:
          this.formFields.extension = msg;
          break;
      }

      this.currentField++;
      this.navigateField();
    },

    navigateField: function() {
      console.log(this.currentField);
      switch (this.currentField) {
        case 0:
          this.readOutLoud('First Name?');
          break;
        case 1:
          this.readOutLoud('Last Name?');
          break;
        case 2:
          this.readOutLoud('Department?');
          break;
        case 3:
          this.readOutLoud('Position?');
          break;
        case 4:
          this.readOutLoud('Role?');
          break;
        case 5:
          this.readOutLoud('Mobile?');
          break;
        case 6:
          this.readOutLoud('Email?');
          break;
        case 7:
          this.readOutLoud('Extension?');
          break;
      }

      this.startListining();
    },
  },
};
</script>



<style scoped>
.about {
  width: 100%;
}
.card-animate-2 {
  animation-name: slideExpandUp;
  /* position: relative;
  position-fromtop: 100px; */
  animation-duration: 3s;
  transition: opacity 1s Elastic.easeIn;
}

.slideExpandUp {
  animation-name: slideExpandUp;
  -webkit-animation-name: slideExpandUp;

  animation-duration: 2.7s;
  -webkit-animation-duration: 2.7s;

  animation-timing-function: ease-out;
  -webkit-animation-timing-function: ease -out;

  visibility: visible !important;
}

@keyframes slideExpandUp {
  0% {
    transform: translateY(100%) scaleX(0.94);
  }
  30% {
    transform: translateY(-4%) scaleX(0.95);
  }
  40% {
    transform: translateY(2%) scaleX(0.96);
  }
  50% {
    transform: translateY(0%) scaleX(1);
  }
}

@-webkit-keyframes slideExpandUp {
  0% {
    -webkit-transform: translateY(100%) scaleX(0.94);
  }
  30% {
    -webkit-transform: translateY(-4%) scaleX(0.95);
  }
  40% {
    -webkit-transform: translateY(2%) scaleX(0.96);
  }
  50% {
    -webkit-transform: translateY(0%) scaleX(1);
  }
}

.image {
  top: 1.5%;
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  opacity: 0.02;
  -webkit-animation: fadeIn 40s ease infinite;
  -moz-animation: fadeIn 40s ease infinite;
  -o-animation: fadeIn 40s ease infinite;
  -ms-animation: fadeIn 40s ease infinite;
  animation: fadeIn 40s ease infinite;
}

@keyframes fadeIn {
  0% {opacity:0; blur:0;}
  25% {opacity:0.1; blur:4;}
  50% {opacity:0.16; blur:25;}
  75% {opacity:0.05; blur:8;}
  100% {opacity:0; blur:0;}
}

@-moz-keyframes fadeIn {
  0% {opacity:0; blur:0;}
  25% {opacity:0.1; blur:4;}
  50% {opacity:0.16; blur:25;}
  75% {opacity:0.05; blur:8;}
  100% {opacity:0; blur:0;}
}

@-webkit-keyframes fadeIn {
  0% {opacity:0; blur:0;}
  25% {opacity:0.1; blur:4;}
  50% {opacity:0.16; blur:25;}
  75% {opacity:0.05; blur:8;}
  100% {opacity:0; blur:0;}
}

@-o-keyframes fadeIn {
  0% {opacity:0; blur:0;}
  25% {opacity:0.1; blur:4;}
  50% {opacity:0.16; blur:25;}
  75% {opacity:0.05; blur:8;}
  100% {opacity:0; blur:0;}
}

@-ms-keyframes fadeIn {
  0% {opacity:0; blur:0;}
  25% {opacity:0.1; blur:4;}
  50% {opacity:0.16; blur:25;}
  75% {opacity:0.05; blur:8;}
  100% {opacity:0; blur:0;}
}
@media only screen and (max-width: 600px) {

  .image {
  overflow-y: hidden;
  background-size: 400% 400%;
  padding: 0px;
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  opacity: 0.4;
  }
}

.avatar {
  margin:3.2%;
  position:absolute; 
  top: -26px
}

@media only screen and (max-width: 600px) {
  .avatar {
    margin:10%;
    position:absolute; 
    top: 15px
  }
}


.db-content {
  background: #304057;
  background-size: 400% 400%;
  padding: 40px;
  min-height: 90vh;
  -webkit-animation: gradient 25s ease infinite;
  -animation: gradient 25s ease infinite;
}

.btn-right {
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
}
.mg-lr14 {
  margin: 0px 14px;
}

.scroll {
  overflow-y: scroll;
  height: 100%;
}

.date-picker {
  flex: 1 1 0%;
  padding: 17px;
  border: 1px solid #fff;
  height: 53px;
  width: auto;
  color: #fff;
  margin: 0 14px;
  border-radius: 5px;
}
.title {
  font-size: 40px;
  font-weight: 300;
}
.user-ui {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 0 14px;
}
.theme-bg-card {
  background: rgba(48, 64, 87, 0.8);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
  height: 400px;
}

.theme-bg-card:hover {
  background: rgba(48, 64, 87, 0.8);
  outline-color: #42da91;
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #42da91;
  box-shadow: 0 0 10px rgba(90, 128, 191, 0.2),
    inset 0 0 10px rgba(90, 128, 191, 0.1), 0 0px 0 #000;
  color: #efe;
  outline: 20px;
}

.theme-bg-card-2 {
  background: rgba(48, 64, 87, 0.6);
  outline-color: #5a80bf;
  color: #fff;
  width: 100%;
}

.theme-bg-card-3 {
  background: rgba(48, 64, 87, 0.5);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
  height: 75vh;
  top: -5rem;
}

.theme-bg-card-3:hover {
  background: rgba(48, 64, 87, 0.9);
  outline-color: #42da91;
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #42da91;
  box-shadow: 0 0 10px rgba(90, 128, 191, 0.2),
    inset 0 0 10px rgba(90, 128, 191, 0.1), 0 0px 0 #000;
  color: #efe;
  outline: 20px;
}

.theme-bg-card-4 {
  background: rgba(48, 64, 87, 0.85);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
  height: 20vh;
}

.thrash {
  font-size: 20px;
  cursor: pointer;
}

.btn-text {
  cursor: pointer;
  display: inline-block;
  font-size: 11px;
  font-weight: 200;
  line-height: 1.42857;
  margin-bottom: 0;
  padding: 6px 5px;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
}

@media (min-width: 600px) {
  .btn-text {
    cursor: pointer;
    display: inline-block;
    font-size: 14px;
    font-weight: 300;
    line-height: 1.42857;
    margin-bottom: 0;
    padding: 6px 12px;
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;
  }
}

.animation3 {
  position: sticky;
  font-size: 15px;
  min-height: 0px;
  left: 0px;
  right: 0px;
  border-radius: 10px;
  color: #fff;
}

.animation4 {
  font-size: 15px;
  min-height: 100S0px;
  left: 0px;
  right: 0px;
  border-radius: 10px;
  color: #fff;
}

.card-animate {
  animation-name: slideleft;
  /* position: relative;
  position-fromtop: 100px; */
  animation-duration: 1.75s;
  transition: opacity 1s easeIn;
}
.card-animate-out {
  animation-name: slideright;
  /* position: relative; */
  /* position-fromtop: 100px; */
  animation-duration: 1s;
  transition: opacity 1s easeOut;
}

/* Standard syntax */
@keyframes slideleft {
  0% {
    left: -800px;
    top: -40px;
    opacity: 0;
  }
  100% {
    left: 92px;
    top: -40px;
    opacity: 1;
  }
}
/* Standard syntax */
@keyframes slideright {
  0% {
    left: 800px;
    top: 0px;
  }
  100% {
    left: 0px;
    top: 0px;
  }
}
@keyframes slidetop {
  0% {
    bottom: -1000px;
    top: 0px;
  }
  100% {
    bottom: 10px;
    top: 0px;
  }
}
@keyframes slidebottom {
  0% {
    bottom: 1000px;
    top: 0px;
  }
  100% {
    bottom: 10px;
    top: 0px;
  }
}
.popup-container {
  max-height: 90vh;
  width: 90vw;
  background: rgba(48, 64, 87, 0.6);
  padding: 10px 40px;
}
.font-weight-thin {
  margin-top: 2rem;
  margin-bottom: 2rem;
  font-weight: 600;
}
.d-flex-row {
  display: flex;
  flex-direction: row;
}
.d-flex-col {
  display: flex;
  flex-direction: column;
}
.date-picker {
  flex: 1 1 0%;
  padding: 17px;
  border: 1px solid #fff;
  height: 53px;
  width: auto;
  color: #fff;
  margin: 0 14px;
  border-radius: 5px;
}
.form-control {
  border: 1px solid #5e6570;
  padding: 10px 5px;
  border-radius: 5px;
  font-size: 14px;
  background: transparent;
  color: #fff;
}
.space1 {
  height: 30px;
}
.space2 {
  height: 50px;
}

.action-btn {
  font-size: 20px;
  cursor: pointer;
  position: relative;
  top: 5px;
}

.product-list {
  position: absolute;
  margin-left: -284px;
  margin-top: 46px;
  padding: 0px;
  list-style: none;
  background: rgba(48, 64, 87, 0.3);
  color: rgb(255, 255, 255);
  /* padding: 15px 0px 0px 0px; */
  line-height: 2;
  max-height: 200px;
  overflow: auto;
}

.item {
  padding: 10px;
  border-bottom: 1px solid #ccc;
  cursor: pointer;
}
.item:hover {
  background: rgba(48, 64, 87, 0.8);
}
.calc {
  width: 200px;
  margin-bottom: 20px;
}

.loader {
  border: 3px solid #f3f3f3;
  border-radius: 50%;
  border-top: 3px solid #3498db;
  width: 15px;
  height: 15px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
  position: absolute;
  margin-top: 16px;
  margin-left: 260px;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
